/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
import React from "react";

import DateFnsUtils from '@date-io/date-fns';
import { Dialog, DialogContent, DialogTitle, Paper, TextField } from "@material-ui/core";
import "cropperjs/dist/cropper.css";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ptLocale from 'date-fns/locale/pt-BR';
import moment from "moment/moment";
import Draggable from 'react-draggable';

import Button from 'components/Button/button';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-nfce-update-item"
      cancel='[class*="MuiDialogContent-root"]'
    >
      <Paper {...props} />
    </Draggable>
  );
}

function UpdateNfceHeaderDialog({
  onClose,
  open,
  confirmationNfceItem,
  currentHeader,
  setCurrentHeader,
  handleUpdateHeader,
  handleGetCnpjInfos
}) {
  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose()
      }}
      className="defaultModal nfceUpdateHeaderDialog customZIndex"
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        className="modalHeader bold textAlignCenter cursorMove"
        id="draggable-dialog-nfce-update-item"
        fullWidth
      >
        DADOS OBRIGATÓRIOS
      </DialogTitle>

      <DialogContent className="modalContent bgWhite dFlex justifyBetween flexColumn alignCenter">
        <div className="defaultItemLine">
          <span>
            NÚMERO NFCE
          </span>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            name="quantity"
            type="number"
            value={currentHeader?.number}
            onChange={(e) => {
              setCurrentHeader({
                ...currentHeader,
                number: e?.target?.value
              })
            }}
            className="textFieldSmall"
            placeholder="Digite aqui..."
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{ style: { fontFamily: 'Lato' } }}
          />
        </div>

        <div className="defaultItemLine">
          <span>
            DATA
          </span>

          <MuiPickersUtilsProvider
            utils={DateFnsUtils}
            locale={ptLocale}
          >
            <KeyboardDatePicker
              className="dateSmall"
              size="small"
              id="time-picker"
              placeholder="00/00/0000"
              format="dd/MM/yyyy"
              ampm={false}
              inputVariant="outlined"
              clearable
              fullWidth
              autoOk
              value={moment(currentHeader?.date)}
              onChange={(value) => {
                if (value) {
                  setCurrentHeader({
                    ...currentHeader,
                    date: value
                  })
                }
              }}
              InputProps={{
                style: { fontFamily: 'Lato', fontSize: '12px' }
              }}
              KeyboardButtonProps={{
                size: 'small',
                'aria-label': 'change time',
                style: { outline: 0 }
              }}
              PopoverProps={{ style: { outline: 0 } }}
            />
          </MuiPickersUtilsProvider>
        </div>

        <div className="defaultItemLine">
          <span>
            CHAVE DE ACESSO
          </span>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            name="quantity"
            type="number"
            value={currentHeader?.accessKey}
            onChange={(e) => {
              setCurrentHeader({
                ...currentHeader,
                accessKey: e?.target?.value
              })
            }}
            className="textFieldSmall"
            placeholder="Digite aqui..."
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{ style: { fontFamily: 'Lato' } }}
          />
        </div>

        <div className="defaultItemLine">
          <span>
            CNPJ
          </span>

          <TextField
            fullWidth
            size="small"
            variant="outlined"
            name="quantity"
            type="number"
            value={currentHeader?.provider?.cnpj}
            onChange={(e) => {
              setCurrentHeader({
                ...currentHeader,
                provider: {
                  ...currentHeader?.provider,
                  cnpj: e?.target?.value,
                  name: !e?.target?.value ? '' : currentHeader?.provider?.name
                }
              })
            }}
            onBlur={(e) => {
              const currentValue = e?.target?.value

              if (currentValue !== confirmationNfceItem?.provider?.cnpj && currentValue?.length === 14) {
                handleGetCnpjInfos(e?.target?.value)
              }
            }}
            className="textFieldSmall"
            placeholder="Digite aqui..."
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{ style: { fontFamily: 'Lato' } }}
          />
        </div>

        {currentHeader?.provider?.cnpj && currentHeader?.provider?.name ?
          <div className="defaultItemLine">
            <span>
              RAZÃO SOCIAL
            </span>

            <TextField
              fullWidth
              size="small"
              variant="outlined"
              name="quantity"
              disabled
              value={currentHeader?.provider?.name}
              onChange={(e) => {
                setCurrentHeader({
                  ...currentHeader,
                  provider: {
                    ...currentHeader?.provider,
                    name: e?.target?.value
                  }
                })
              }}
              className="textFieldSmall"
              placeholder="Digite aqui..."
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{ style: { fontFamily: 'Lato', paddingLeft: 8 } }}
            />
          </div>
        : null}

        {currentHeader?.accessKey?.length !== 44 
        ?
          <span className="invalidField">
            Chave de acesso inválida - {currentHeader?.accessKey?.length} de 44 caracteres
          </span>
        : null}

        <div className="editItemActionButtons">
          <Button 
            onClick={() => {
              onClose()
            }}
            className="defaultButton backButton"
            design="outlined"
            label="Cancelar"
          />

          <Button 
            disabled={!currentHeader?.provider?.name}
            onClick={() => {
              handleUpdateHeader()
            }}
            className="defaultButton submitButton"
            design="outlined"
            label="Salvar"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
  
export default UpdateNfceHeaderDialog;